import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "px-4 pb-4"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "flex py-2 mb-20"
};
const _hoisted_4 = {
  class: "w-1/3"
};
const _hoisted_5 = {
  class: "text-base py-2"
};
const _hoisted_6 = {
  class: "py-2"
};
const _hoisted_7 = {
  key: 0,
  class: "w-1/3"
};
const _hoisted_8 = {
  class: ""
};
const _hoisted_9 = {
  key: 0,
  class: "alert alert-warning"
};
const _hoisted_10 = {
  class: "text-base py-2"
};
const _hoisted_11 = {
  class: "space-y-2 py-2"
};
const _hoisted_12 = {
  class: "py-2"
};
import { reactive, computed, onMounted } from 'vue';
import RouteService from '@/services/RouteService';
import useClientMatterStore from '@/services/useClientMatterStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';

// Component Imports
import LlTooltip from '@/components/LlTooltip.vue';
import Loader from '@/components/Loader.vue';
import LlSwitch from '@/components/LlSwitch.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTextField from '@/components/LlTextField.vue';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
export default {
  __name: 'ClientLedes',
  props: {
    stateParams: Object,
    state: Object,
    rootScope: Object
  },
  setup(__props) {
    const props = __props;
    const clientMatterStore = useClientMatterStore();
    const routeService = new RouteService(props);
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const clientLedesState = reactive({
      loading: false,
      unsaved: false,
      saving: false,
      originalForm: {},
      form: {
        ledes: false,
        invoiceDescription: '',
        externalId: '',
        clientTaxId: '',
        clientLawFirmId: '',
        insertClientContactInfo: false,
        insertCountryAsWorkLocation: false,
        insertFixedFeesAsTimeEntries: false,
        specialExpenseFormat: false,
        includeZeroDollarItems: null,
        required: {
          activity: false,
          task: false,
          expense: false
        },
        format: null
      },
      formats: [{
        id: 'ledes98',
        label: 'LEDES 1998b'
      }, {
        id: 'ledes2000',
        label: 'LEDES 2000'
      }, {
        id: 'ledesLss',
        label: 'LEDES LSS'
      }, {
        id: 'ledesXml2',
        label: 'LEDES XML 2.0'
      }]
    });
    const noFormatSelected = computed(() => {
      return clientLedesState.form.ledes && clientLedesState.form.format == null;
    });
    onMounted(async () => {
      await loadClient();
      setupRouteChangeHandler();
    });
    function loadClient() {
      const requestedClientId = props.stateParams?.id;
      if (!requestedClientId) {
        return Promise.resolve();
      }
      clientLedesState.loading = true;
      // Force a fresh fetch every visit - LEDES settings can change from another
      // tab/user/bulk action, and the store's per-id memoization would otherwise
      // silently serve a stale cached client for the rest of the session.
      return clientMatterStore.getClientById(requestedClientId, true).then(client => {
        // Ignore stale responses if the user switched clients mid-request.
        if (String(props.stateParams?.id) !== String(requestedClientId)) {
          return;
        }
        clientLedesState.originalForm = hydrateForm(client?.settings?.codes);
        resetForm();
        clientLedesState.loading = false;
      }).catch(err => {
        clientLedesState.loading = false;
        handleError(err);
      });
    }
    function setupRouteChangeHandler() {
      routeService.rootScopeChange().$on('$stateChangeStart', event => {
        if (somethingChanged.value) {
          clientLedesState.unsaved = true;
          setTimeout(() => {
            clientLedesState.unsaved = false;
          }, 4000);
          event.preventDefault();
        }
      });
    }
    function hydrateForm(source = {}) {
      return {
        format: clientLedesState.formats?.find(format => format.id === source?.format) || null,
        ledes: source.ledes || false,
        invoiceDescription: source.invoiceDescription || '',
        externalId: source.externalId || '',
        clientTaxId: source.clientTaxId || '',
        clientLawFirmId: source.clientLawFirmId || '',
        insertClientContactInfo: source.insertClientContactInfo || false,
        insertCountryAsWorkLocation: source.insertCountryAsWorkLocation || false,
        insertFixedFeesAsTimeEntries: source.insertFixedFeesAsTimeEntries || false,
        specialExpenseFormat: source?.specialExpenseFormat || false,
        // Note: includeZeroDollarItems is left without a fallback because it's a nullable boolean.
        includeZeroDollarItems: source?.includeZeroDollarItems,
        required: {
          activity: source.required?.activity || false,
          task: source.required?.task || false,
          expense: source.required?.expense || false
        }
      };
    }
    function resetForm() {
      clientLedesState.form = JSON.parse(JSON.stringify(clientLedesState.originalForm));
    }
    const somethingChanged = computed(() => JSON.stringify(clientLedesState.form) !== JSON.stringify(clientLedesState.originalForm));
    const update = async () => {
      const requestedClientId = props.stateParams?.id;
      if (!requestedClientId) {
        return;
      }
      clientLedesState.saving = true;
      clientLedesState.unsaved = false;
      try {
        const client = await clientMatterStore.updateClient({
          id: requestedClientId,
          update: {
            settings: {
              codes: {
                ...clientLedesState.form,
                format: typeof clientLedesState.form.format === 'object' ? clientLedesState.form.format.id : clientLedesState.form.format
              }
            }
          }
        });

        // updateClient returns null when user navigates away before response arrives.
        // Also ignore stale responses if route switched while request was in flight.
        if (!client || String(props.stateParams?.id) !== String(requestedClientId)) {
          return;
        }
        clientLedesState.originalForm = hydrateForm(client.settings?.codes);
        resetForm();
        handleSuccess("Client's LEDES settings updated successfully.");
      } catch (err) {
        handleError(err);
      } finally {
        clientLedesState.saving = false;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), clientLedesState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: "LEDES settings",
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "w-1/2"
      }, " These are your LEDES settings for this client. To make changes at the matter level, click the matter on the left and navigate to the LEDES tab. ", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "text-lg py-2"
      }, "LEDES Billing", -1)), _createElementVNode("div", _hoisted_5, [_cache[15] || (_cache[15] = _createTextVNode(" Enable LEDES for this Client ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("While enabled, allows assigning LEDES codes to time entries, expenses, and fixed fees", -1)]))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createVNode(LlSwitch, {
        modelValue: clientLedesState.form.ledes,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => clientLedesState.form.ledes = $event),
        "data-cy": "client-ledes"
      }, null, 8, ["modelValue"])])]), clientLedesState.form.ledes ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "text-base py-2"
      }, "Client Settings", -1)), _createElementVNode("div", _hoisted_8, [_createVNode(LlSelect, {
        modelValue: clientLedesState.form.format,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => clientLedesState.form.format = $event),
        items: clientLedesState.formats,
        "item-title": "label",
        "item-value": "id",
        "return-object": "",
        placeholder: "LEDES Format",
        variant: "outlined",
        label: "LEDES Format",
        info: "This determines which format the LEDES file will be exported in.",
        labelClass: "text-sm at-choose-client remove-outline",
        "data-cy": "LEDES-Format-dropdown",
        isAutocomplete: ""
      }, null, 8, ["modelValue", "items"]), noFormatSelected.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, " LEDES format is required ")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, [_cache[18] || (_cache[18] = _createTextVNode(" Required Codes ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("Your client might require some of the codes for time and expenses. If set to required you will have to provide a code when doing a time entry or expense.", -1)]))]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(LlCheckbox, {
        label: "Activity Codes",
        modelValue: clientLedesState.form.required.activity,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => clientLedesState.form.required.activity = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        label: "Task Codes",
        modelValue: clientLedesState.form.required.task,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => clientLedesState.form.required.task = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        label: "Expense Codes",
        modelValue: clientLedesState.form.required.expense,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => clientLedesState.form.required.expense = $event)
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_11, [_createVNode(LlTextField, {
        label: "Default Invoice Description",
        placeholder: "Draft/Interim/Final",
        info: "This overrides the description normally assigned to invoices (draft = \"Draft\", approved =\n                \"Interim\", open = \"Final\").",
        modelValue: clientLedesState.form.invoiceDescription,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => clientLedesState.form.invoiceDescription = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        label: "LEDES Law Firm Client Id",
        info: "Maps to CLIENT_ID in legacy LEDES format and cl_id in LEDES XML 2.0. If blank, uses client number in LeanLaw or company initials.",
        modelValue: clientLedesState.form.externalId,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => clientLedesState.form.externalId = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        label: "Client Tax Id",
        info: "This field maps to cl_tax_id in LEDES XML 2.0.",
        modelValue: clientLedesState.form.clientTaxId,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => clientLedesState.form.clientTaxId = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        label: "Client Law Firm ID",
        info: "Uniquely identifies the law firm to the client and maps to cl_lf_id in LEDES XML 2.0. Defaults to the firm tax ID. if left blank.",
        modelValue: clientLedesState.form.clientLawFirmId,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => clientLedesState.form.clientLawFirmId = $event)
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_createVNode(LlCheckbox, {
        label: "Insert Client Contact Info ",
        modelValue: clientLedesState.form.insertClientContactInfo,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => clientLedesState.form.insertClientContactInfo = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        label: "Insert Country as Work Location",
        info: "Will add country work location in LEDES XML format for fees and expenses. For Special Format Expenses, will correspond to Vendor's country set in QuickBooks. Otherwise, will correspond to the firm's country set in Firm Info.",
        modelValue: clientLedesState.form.insertCountryAsWorkLocation,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => clientLedesState.form.insertCountryAsWorkLocation = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        label: "Insert fixed fees as Time Entries",
        info: "When enabled inserts fixed fees as time entries (U) in LEDES XML 2.0 invoices. Rate is the Fixed Fee amount, and quantity is 1.",
        modelValue: clientLedesState.form.insertFixedFeesAsTimeEntries,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => clientLedesState.form.insertFixedFeesAsTimeEntries = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        label: "Special Expense Format",
        info: "In special format expenses, as set in Settings > LEDES, expense descriptions in LEDES XML 2.0 will be formatted '[vendor name]#description of expense'.",
        modelValue: clientLedesState.form.specialExpenseFormat,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => clientLedesState.form.specialExpenseFormat = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        label: "Include $0 Items in LEDES",
        info: "Control whether $0 time entries, expenses, and fixed fees are included in LEDES exports. Default behavior excludes $0 items.",
        modelValue: clientLedesState.form.includeZeroDollarItems,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => clientLedesState.form.includeZeroDollarItems = $event),
        "data-cy": "include-zero-dollar-items"
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)]), _createVNode(SettingsSaveBar, {
        somethingChanged: somethingChanged.value,
        saving: clientLedesState.saving,
        unsaved: clientLedesState.unsaved,
        state: __props.state,
        stateParams: __props.stateParams,
        showFullWidth: "",
        onCancel: resetForm,
        onUpdate: update,
        disabled: noFormatSelected.value
      }, null, 8, ["somethingChanged", "saving", "unsaved", "state", "stateParams", "disabled"])]))]);
    };
  }
};